<template>
  <b-form @submit.prevent="onSubmit" novalidate class="label-bold" autocomplete="off">
    <b-form-group label-for="input-receivers" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        To:
      </template>
      <multiselect
        v-if="showToSelection"
        id="input-receivers"
        v-model="form.receivers"
        label="name"
        track-by="name"
        :options="toOptions"
        hide-selected
        :show-labels="false"
        multiple
        placeholder=""
        :class="{'is-invalid': isValidField('receivers') === false}"
      />
      <span v-else>
        {{computedReceivers}}
      </span>
      <b-form-invalid-feedback :state="isValidField('receivers')">
        <div v-for="error in errors.receivers || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-category" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        Category
      </template>
      <b-form-select id="input-category" v-model="form.category" :state="isValidField('category')">
        <b-form-select-option
          v-for="option in categories"
          :key="option.value"
          :value="option.value">
          {{option.text}}
        </b-form-select-option>
      </b-form-select>
      <b-form-invalid-feedback :state="isValidField('category')">
        <div v-for="error in errors.category || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-content" label-cols-sm="4" label-cols-lg="3">
      <template #label>
        Content
      </template>
      <b-form-textarea
        id="input-content"
        :value="computedContent"
        rows="15"
        :state="isValidField('content')"
        placeholder="Content"
        @update="form.content = $event"
      />
      <b-form-invalid-feedback :state="isValidField('content')">
        <div v-for="error in errors.content || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-row class="justify-content-end mt-5">
      <b-col cols="auto">
        <b-button type="submit" :disabled="submitting" pill variant="primary" class="pl-5 pr-5">Send</b-button>
      </b-col>
    </b-form-row>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'
import { CATEGORY_TYPE, RECEIVER_TYPE } from '@/helpers/types'
import { userName } from '@/helpers/helpers'
import { DefaultContent } from '@/helpers/messageContent'

export default {
  name: 'SendMessageForm',

  mixins: [MixinForm],

  props: {
    receivers: {
      type: Array,
      default: () => ([])
    },

    profiles: {
      type: Array,
      default: () => ([])
    },

    teams: {
      type: Array,
      default: () => ([])
    }
  },

  watch: {
    receivers(value) {
      this.form.receivers = value.map(p => ({ value: p.receiver.id, type: p.type }))
    }
  },

  data() {
    return {
      form: {
        receivers: this.receivers.map(p => ({ value: p.receiver.id, type: p.type })),
        category: '',
        content: ''
      },
      categories: [
        { value: CATEGORY_TYPE.THANKYOU, text: 'Thank You' },
        { value: CATEGORY_TYPE.FEEDBACK, text: 'Feedback' },
        { value: CATEGORY_TYPE.COACHING, text: 'Coaching' },
        { value: CATEGORY_TYPE.WELCOME, text: 'Welcome' }
      ]
    }
  },

  computed: {
    showToSelection() {
      return this.receivers.length === 0
    },

    computedReceivers() {
      return this.receivers.map(p => {
        return p.type === RECEIVER_TYPE.USER ? userName(p.receiver) : p.receiver.name
      }).join('; ')
    },

    toOptions() {
      if (!this.showToSelection) return []
      const profiles = this.profiles.map(p => ({ value: p.id, type: RECEIVER_TYPE.USER, name: `${userName(p)} (${p.email})` }))
      const teams = this.teams.map(p => ({ value: p.id, type: RECEIVER_TYPE.TEAM, name: p.name }))
      return [...profiles, ...teams]
    },

    computedContent() {
      return this.form.content || DefaultContent[this.form.category] || ''
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (validator.isEmpty(data.category || '')) errors.category = ["Category can't be blank"]
      if (validator.isEmpty(this.computedContent)) errors.content = ["Content can't be blank"]
      if (!data.receivers.length) errors.receivers = ["To can't be blank"]
      return errors
    },

    prepare(data) {
      const { receivers, content, ...other } = data
      return {
        ...other,
        content: this.computedContent,
        receivers: receivers.map(p => ({ id: p.value, type: p.type }))
      }
    }
  }
}
</script>
